import { Link } from '@iclinic/iclinic-ui';
import { routerLink } from 'shared/utils/router';

export default routerLink(Link);
